import React, { useState } from "react";

import Iconify from "../iconify";
import CallBackRequest from "./callBackRequest";
import { CUSTOMER_CARE_TEL, VISITTYPE, FOR_MOBILE_VIEW } from "@/src/lib/util/config";
import { initiateCall } from "@/src/lib/util/callUtils";
import useAuth from "@/src/lib/hooks/useAuth";
import Image from "next/image";
import IconCode from "@/src/lib/iconCode";
const ActionButtons = ({
    currentTest,
    currentCentre,
    testDetails,
    addToCartHandler,
    visitType,
    addressDetails,
    setIsAddressListOpen,
    setLoginPopUp,
}) => {
    // console.log(
    //     currentTest,
    //     "currentTestcurrentTestcurrentTest",
    //     currentCentre
    // );

    const { isLoggedIn } = useAuth();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { configButtons, isOfflineOnly } = testDetails || {};

    const handleCartButton = () => {
        if (visitType === VISITTYPE.HOME && !isLoggedIn) {
            setLoginPopUp(true);
            return;
        }

        if (
            visitType === VISITTYPE.HOME &&
            (!addressDetails || Object.values(addressDetails).length === 0)
        ) {
            setIsAddressListOpen(true);
            return;
        }

        addToCartHandler(currentCentre, currentTest);
    };

    const getCartButtonText = () => {
        if (visitType === VISITTYPE.CENTRE) {
            return isLoggedIn ? "Book Now" : "Add to Cart";
        } else if (visitType === VISITTYPE.HOME) {
            if (!isLoggedIn) {
                return "Login to Book Now";
            } else if (
                !addressDetails ||
                Object.values(addressDetails).length === 0
            ) {
                return "Select Address";
            } else {
                return "Add to Cart";
            }
        }
        return "Add to Cart";
    };

    const primaryButtonClass =
        "group inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg bg-linear-to-b from-[#d10a0a] to-[#b30000] px-4 py-3 text-[15px] font-semibold capitalize text-white shadow-sm shadow-primary/25 transition-all duration-200 hover:from-[#c00000] hover:to-[#9f0000] hover:shadow-md hover:shadow-primary/25 active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2";

    const secondaryButtonClass =
        "inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-solid border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-800 transition-colors duration-200 hover:border-primary/40 hover:bg-primary/5 hover:text-primary active:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30";

    return (
        <div className="flex flex-col items-center border-t border-slate-100 p-5 md:p-6">
            <div className="w-full flex flex-col gap-2.5">
                {/* Config Buttons */}
                {configButtons && configButtons.length > 0 && (
                    <div className="w-full flex flex-col gap-2.5">
                        {configButtons.map((button, index) => (
                            <button
                                key={index}
                                type="button"
                                className={primaryButtonClass}
                                onClick={() =>
                                    (window.location.href = button.buttonLink)
                                }
                            >
                                {button.buttonIcon && (
                                    <Iconify
                                        icon={button.buttonIcon}
                                        className="text-white"
                                    />
                                )}
                                {button.buttonName}
                            </button>
                        ))}
                    </div>
                )}

                {isOfflineOnly !== 1 &&
                    (visitType === VISITTYPE.CENTRE &&
                    currentCentre?.ownedBy == "f" ? (
                        <p className="rounded-lg bg-amber-50 px-3 py-2.5 text-center text-sm leading-5 text-amber-800 ring-1 ring-amber-100">
                            This centre requires an offline booking. Please call
                            the centre below.
                        </p>
                    ) : (
                        <button
                            type="button"
                            onClick={handleCartButton}
                            className={primaryButtonClass}
                        >
                            {getCartButtonText()}
                            <Image
                                src="/images/arrow_left.svg"
                                alt="Proceed"
                                width={0}
                                height={0}
                                className="rotate-90 w-6 h-6 transition-transform duration-200 group-hover:translate-x-0.5"
                            />
                        </button>
                    ))}

                {visitType === VISITTYPE.HOME ? (
                    <button
                        type="button"
                        className={secondaryButtonClass}
                        onClick={() => {
                            initiateCall(FOR_MOBILE_VIEW || CUSTOMER_CARE_TEL);
                        }}
                    >
                        <Iconify
                            icon={IconCode?.phoneCall}
                            className="shrink-0 text-primary"
                        />
                        {"Call Customer Care"}
                    </button>
                ) : (
                    !!currentCentre && (
                        <button
                            type="button"
                            className={secondaryButtonClass}
                            onClick={() => {
                                if (currentCentre?.mobileNo) {
                                    initiateCall(currentCentre?.mobileNo);
                                }
                            }}
                        >
                            <Iconify
                                icon={IconCode?.phoneCall}
                                className="shrink-0 text-primary"
                            />
                            <span className="truncate text-inherit">
                                {"Call " + currentCentre?.centre}
                            </span>
                        </button>
                    )
                )}

                {/* Request a Callback Button */}
                <button
                    type="button"
                    className="inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold text-slate-600 transition-colors duration-200 hover:bg-slate-50 hover:text-slate-900 active:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
                    onClick={() => setIsPopupOpen(true)}
                >
                    <Iconify
                        icon="material-symbols:call-log-outline-rounded"
                        width={18}
                        className="shrink-0 text-slate-400"
                    />
                    Request a Callback
                </button>
            </div>
            <CallBackRequest
                isLoggedIn={1} // or 1 depending on logged-in status
                userDetails={[]}
                open={isPopupOpen}
                onClose={() => setIsPopupOpen(false)}
                currentTest={currentTest}
                currentCentre={currentCentre}
            />
        </div>
    );
};

export default ActionButtons;
